import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DialogConfigInterface} from '@shared/model';
import {DialogService} from '@shared/service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnChanges {
  @Input() config?: DialogConfigInterface;

  constructor(public dialogService: DialogService) {
  }

  ngOnChanges(_: SimpleChanges) {
    if (this.config?.show) {
      this.dialogService.setFirst(this.config!.id);
    }
  }

  onClick(): void {
    if (!this.config!.isFirstPlan) {
      this.dialogService.setFirst(this.config!.id);
    }
  }

  onClose(): void {
    this.dialogService.toggleShow(this.config!.id, false);
  }
}
